import { useSettings } from './useSetting';

export function useTheme(): [string, (value: string | undefined) => void] {
	const { settings, setValue } = useSettings();
	const theme = settings.theme ?? 'default';
	const setTheme = (value: string | undefined) => setValue('theme', value);
	return [theme, setTheme];
}
